export enum ERROR_MESSAGE {
  WRONG_CREDENTIAL = "WrongCredential",
  REQUIRED_PASSWORD = "ReruiredPassword",
  REQUIRED_OLD_PASSWORD = "ReruiredOldPassword",
  REQUIRED_NEW_PASSWORD = "ReruiredNewPassword",
  PASSWORD_NOT_MATCH = "PasswordNotMatch",
  REQUIRED_BANK_NAME = "RequiredBankName",
  REQUIRED_ACCOUNT_NAME = "RequiredAccountName",
  REQUIRED_ACCOUNT_NO = "RequiredAccountNo",
  REQUIRED_AMOUNT = "RequiredAmount",
  REQUIRED_BANKNAME_ENG = "RequiredBankNameEng",
  DOC_EXIST = "DocExist",
  TRANSACTION_NOT_AVAILABLE = "TransactionNotAvailable",
  TRANSACTION_NOT_FOUND = "TransactionNotFound",
  INSUFFICIENT = "Insufficient",
  ROOM_NOT_FOUND = "RoomNotFound",
  USER_NOT_SET_WITHDRAW_PASSWORD = "UserNotSetWithdrawPassword",
  MAX = "MaxBet",
  USER_BLOCKED = "UserBlocked",
  REQUIRED_CRYPTO_ADDRESS = "REQUIRED_CRYPTO_ADDRESS",
  REQUIRED_CRYPTO_NETWORK = "REQUIRED_CRYPTO_NETWORK",
  REQUIRED_NAME = "REQUIRED_NAME",
  REQUIRED_LASTNAME = "REQUIRED_LASTNAME",
  REQUIRED_PROFIT = "REQUIRED_PROFIT",
  REQUIRED_USERNAME = "REQUIRED_USERNAME",
  REQUIRED_CATEGORY = "REQUIRED_CATEGORY",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  REQUIRED_PASSWORD_CONFIRM = "ReruiredPasswordConfirm",
  REQUIRED_COUNTRY = "REQUIRED_COUNTRY",
  REQUIRED_GAME = "REQUIRED_GAME",
  REQUIRED_NAME_ENG = "RequiredNameEng",
  REQUIRED_MINIMUM_BALANCE = "REQUIRED_MINIMUM_BALANCE",
  REQUIRED_OPTIONS = "REQUIRED_OPTIONS",
  REQUIRED_ROLE = "REQUIRED_ROLE",
  REQUIRED_PRICE = "REQUIRED_PRICE",
  OLD_PASSWORD_INCORRECT = "OLD_PASSWORD_INCORRECT",
  UNAUTHENTICATED = "UNAUTHENTICATED",
  PERMISSION_DENIED = "PERMISSION_DENIED",
  REQUIRED_CATE_NAME = " REQUIRED_CATE_NAME",
  CATEGORY_IS_EXIST = " CATEGORY_IS_EXIST",
  REQUIRED_VARIANT = " REQUIRED_VARIANT",
  INVALID_ID = " INVALID_ID",
  REQUIRED_FULLNAME = " REQUIRED_FULLNAME",
  REQUIRED_IMAGE = " REQUIRED_IMAGE",
  REQUIRED_NICKNAME = " REQUIRED_NICKNAME",
  REQUIRED_ROOM = "REQUIRED_ROOM",
  WRONG_PASSWORD = "WRONG_PASSWORD",
  MEMBER_NOT_FOUND = "MEMBER_NOT_FOUND",
  REQUIRED_LOTTERY = "REQUIRED_LOTTERY",
  REQUIRED_MEMBER = "REQUIRED_MEMBER",
  REQUIRED_ACTION = "REQUIRED_ACTION",
  REQUIRED_BANK = "REQUIRED_BANK",
  REQUIRED_EMAIL = "REQUIRED_EMAIL",
  INVALID_OTP_CODE = "INVALID_OTP_CODE",
  TRADE_MINIMUM_BALANCE = "TRADE_MINIMUM_BALANCE",
}
